module.exports = __webpack_public_path__ + "img/bg_home_body.3ea12f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg_home_body.png
// module id = pzli
// module chunks = 1